<div class="{{kymw1400KomaPageModel.selectedBarStyle}}" [style.width.%]="100" [style.height.px]="3"
  id="vbox_selectedBar"></div>
<div class="element-column"
  style="height: 100%;padding-top: 8px;padding-left: 16px;padding-right: 16px;padding-bottom: 16px;">
  <div class="element-row">
    <div class="column-list">
      <label class="list-input-title" [tabindex]="-1">会員生協</label>
      <div class="list-input-content">
        <app-coop-code-combo-box id="cmb_Coop" #cmb_Coop [subid]="'cmb_Coop'" [forcedEnabledMode]="'true'"
          [tabindex]="0" (change)="eventCoop_CHANGEHandler()" (focus)="eventCoop_FOCUSHandler()">
        </app-coop-code-combo-box>

        <div class="list-input-content block-row" id="rbtg_radiogroup">
          <app-radio-label label="コマ編集" id="rbtn_Move" #rbtn_Move [name]="leftOrRight" [subid]="'rbtn_Move'"
            [(ngModel)]="kymw1400KomaPageModel.komaType" [value]="kymw1400KomaPageModel.KOMATYPE_MOVE" [tabindex]="0"
            [forcedEnabledMode]="'true'" (change)="eventKomaType_CHANGEHandler()">
          </app-radio-label>
          <app-radio-label label="コマ入替" id="rbtn_Replace" #rbtn_Replace [name]="leftOrRight" [subid]="'rbtn_Replace'"
            [(ngModel)]="kymw1400KomaPageModel.komaType" [value]="kymw1400KomaPageModel.KOMATYPE_REPLACECURSOR"
            [tabindex]="0" [forcedEnabledMode]="'true'" (change)="eventKomaType_CHANGEHandler()">
          </app-radio-label>
          <app-radio-label label="コマ詰め" id="rbtn_Shift" #rbtn_Shift [name]="leftOrRight" [subid]="'rbtn_Shift'"
            [(ngModel)]="kymw1400KomaPageModel.komaType" [value]="kymw1400KomaPageModel.KOMATYPE_SHIFTCURSOR"
            [tabindex]="0" [forcedEnabledMode]="'true'" (change)="eventKomaType_CHANGEHandler()">
          </app-radio-label>
        </div>
      </div>
      <label class="list-input-title" [tabindex]="-1">ページ</label>
      <div class="list-input-content">
        <div class="element-row">
          <button id="btn_Prev" class="icon-button" [disabled]="!kymw1400KomaPageModel.prevEnable"
            (click)="eventPrev_CHANGEHandler()">◀</button>
          <app-page-combo-box id="cmb_Page" #cmb_Page [labelField]="'PageNumInfo'" [subid]="'cmb_Page'"
            [orderCode]="kymw1400Model.orderCode" [mediumType]="kymw1400Model.mediumType"
            [coopCode]="cmb_Coop.selectedCoopCode" (change)="eventPage_CHANGEHandler()"
            (nextFunc)="eventPage_CHANGEHandler()" [forcedEnabledMode]="'true'" [tabindex]="0" [style.width.px]="280">
          </app-page-combo-box>
          <button id="btn_Next" class="icon-button" [disabled]="!kymw1400KomaPageModel.nextEnable"
            (click)="eventNext_CHANGEHandler()">▶</button>
        </div>

        <div class="element-row">
          <label aria-label="キャンセル" data-microtip-position="bottom" role="tooltip">
            <button class="icon-button" id="btn_Cancel" #btn_Cancel forcedEnabledMode="none" [tabindex]="0"
              [disabled]="!kymw1400KomaPageModel.cancelEnable" (click)="eventCancel_CLICKHandler()">
              <img src="{{kymw1400KomaPageModel.cancelEnable ?
                          kymw1400KomaPageModel.srcCancelEnabled : kymw1400KomaPageModel.srcCancelDisabled}}">
            </button>
          </label>

          <label aria-label="編集ロック" data-microtip-position="bottom" role="tooltip">
            <button class="icon-button {{clsPageLock}}" id="btn_PageLock" #btn_PageLock forcedEnabledMode="none"
              [tabindex]="0" [disabled]="!kymw1400KomaPageModel.pageLockEnable" (click)="eventPageLock_CLICKHandler()">
              <img src="{{kymw1400KomaPageModel.srcLock}}">
            </button>
          </label>

          <label aria-label="コマの表示、非表示を切り替えます" data-microtip-position="bottom" role="tooltip">
            <button class="icon-button {{clsKomaShow}}" id="btn_KomaShow" #btn_KomaShow forcedEnabledMode="true"
              [tabindex]="-1" (click)="eventKomaShow_CHANGEHandler()">
              <img src="{{kymw1400KomaPageModel.srcKomaVisible}}">
            </button>
          </label>

          <label aria-label="現在のページをリロードします" data-microtip-position="bottom" role="tooltip">
            <button class="icon-button" id="btn_Reload" #btn_Reload forcedEnabledMode="true" [tabindex]="-1"
              [disabled]="!kymw1400KomaPageModel.reloadEnable" (click)="eventReload_CHANGEHandler()">
              <img src="./assets/icons/KYMW14/reload.png">
            </button>
          </label>
        </div>
      </div>
    </div>
    <div class="element-column">
      <div class="column-list">
        <label class="list-input-title">フォントサイズ</label>
        <div class="list-input-content">
          <select id="cmb_FontSize" #cmb_FontSize [(ngModel)]="kymw1400KomaPageModel.fontSize" forcedEnabledMode="true"
            [tabindex]="-1" (change)="eventFontSize_CHANGEHandler()">
            <ng-template ngFor let-item [ngForOf]="kymw1400KomaPageModel.fontSizeList">
              <option value="{{item}}">{{item}}</option>
            </ng-template>
          </select>
        </div>
      </div>
      <div class="list-input-content koma-screen-size">
        <label id="lbl_ViewRate" forcedEnabledMode="true">{{kymw1400KomaPageModel.sliderValue}}</label>
        <label>%</label>

        <div class="slider-area">
          <input #hsl_Size id="hsl_Size" class="size-slider" type="range" min="50" max="400" step="10"
            forcedEnabledMode="true" [tabindex]="-1" value="{{kymw1400KomaPageModel.sliderValue}}"
            (change)="eventSize_CHANGEHandler();bindSize_CHANGEHandler();" (input)="viewSliderTooltip()">
          <span #sliderTooltip>100.00</span>
        </div>

        <label aria-label="画面サイズにあわせてページを表示します" data-microtip-position="left" role="tooltip">
          <button class="icon-button" id="btn_Adjust" forcedEnabledMode="true" [tabindex]="-1"
            (click)="eventAdjust_CLICKHandler()">
            <img src="./assets/icons/KYMW14/fitsize.png">
          </button>
        </label>
      </div>
    </div>
  </div>
  <hr>
  <div class="element-column" style="height: 100%;">
    <div class="element-row">
      <wj-flex-grid [itemsSource]="kymw1400KomaPageModel.planSummaryTable" id="dgv_PlanSummaryTable"
        #dgv_PlanSummaryTable [isReadOnly]="true" [allowSorting]="false" [allowResizing]="'None'"
        [headersVisibility]="'Column'" [allowDragging]="'None'" [selectionMode]="'Row'" tabindex="-1"
        style="width: 302px; height: 60px;">
        <wj-flex-grid-column [minWidth]="5" [header]="'計画点数'" [width]="79" [binding]="'PlanNum'" [align]="'right'">
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'金額(千円)'" [width]="85" [binding]="'SupplyAmount'"
          [align]="'right'">
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'GPR'" [width]="57" [binding]="'GPR'" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div>{{cell.item.GPR}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'点単価'" [width]="79" [binding]="'SupplyPrice'" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div>{{cell.item.SupplyPrice}}</div>
          </ng-template>
        </wj-flex-grid-column>
      </wj-flex-grid>

      <div class="element-column">
        <div class="column-list">
          <label class="list-input-title">テンプレート名</label>
          <div class="list-input-content" style="width: 26rem;">
            <input type="text" id="txi_TenplateName" plessInputTextSub [restrict]="'[ -￮]'" readonly
              [(ngModel)]="kymw1400KomaPageModel.templateName" />
          </div>
        </div>
        <div class="layout_end">
          <button id="btn_SeqNoSet" #btn_SeqNoSet [tabindex]="-1" class="btn-secondary"
            [disabled]="!kymw1400KomaPageModel.seqNoEnable" (click)="eventSeqNoSet_CLICKHandler()">Seq.No一括セット</button>
        </div>
      </div>
    </div>
    <div id="va_pageView" [style.background-color]="'#B7BABC'" [style.overflow]="'scroll'"
      style="border:solid 1px #B7BABC;" [style.width.%]="100" [style.height.%]="100">
      <app-page id="page" #page [kymw1400KomaPageModel]="kymw1400KomaPageModel" [leftOrRight]="leftOrRight"></app-page>
    </div>
  </div>
</div>